import AbstractBlockType from "~/cabinet/vue/interface/htmlConstructor/blocks/AbstractBlockType";
import ITextBlockValues from "~/cabinet/vue/interface/htmlConstructor/blocks/text/ITextBlockValues";
import TextDisplay from "~/cabinet/vue/interface/htmlConstructor/blocks/text/TextDisplay.vue";
import {
    HTML_CONSTRUCTOR_BLOCK_TOOLBAR_POSITION_BOTTOM,
    HtmlConstructorBlockToolbarPosition
} from "~/cabinet/vue/interface/htmlConstructor/blocks/HtmlConstructorBlockToolbarPosition";
import {RawComponent, useRawComponent} from "~/core-ui/ts/useRawComponent";


export default class TextBlockType extends AbstractBlockType<ITextBlockValues, any> {


    get displayComponent(): RawComponent {
        return useRawComponent(TextDisplay);
    }

    get formComponent(): RawComponent {
        return null;
    }

    get isBlockWithoutPadding(): boolean {
        return true;
    }

    get toolbarPosition(): HtmlConstructorBlockToolbarPosition {
        return HTML_CONSTRUCTOR_BLOCK_TOOLBAR_POSITION_BOTTOM;
    }
}
